module.exports = __webpack_public_path__ + "img/leaf.47bfc5db.png";